var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "화학자재 > 구성물질 > 규제항목 정량값",
          gridHeight: "780px",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          merge: _vm.grid.merge,
          columnSetting: false,
          isFullScreen: false,
          isExcelDown: false,
          filtering: false,
          usePaging: false,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }